/** source data for id generation */
export const idSource = 'abcdefghijklmnopqrstuvwxyz0123456789';
